import { createFileRoute } from '@tanstack/react-router';

type Search = {
  selectedLocationId?: string;
  templateId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/fax/drafts/template-editor')({
  staticData: { team: 'fe-messaging' },
  validateSearch: (search: Partial<Search>): Search => {
    return {
      selectedLocationId: search.selectedLocationId,
      templateId: search.templateId,
    };
  },
});
